export default {
    context: {
        workspace: 'Work space',
        innovationField: 'Innovation field'
    }
}
